<template>
	<div class="lifestyle analysis">
		<div class="statistics card">
			<h5>Analysis</h5>
			<el-row :gutter="10">
				<el-col :span="12">
					<h6>Bristol Stool Type</h6>
					<FormAnalysis :excretion="excretion"></FormAnalysis>
				</el-col>
				<el-col :span="12">
					<h6>Color</h6>
					<ColorAnalysis :excretion="excretion"></ColorAnalysis>
				</el-col>
			</el-row>
		</div>
		<div class="record card">
			<h5>Records</h5>
			<ExcretionTable :excretion="excretion"></ExcretionTable>
		</div>
	</div>
</template>

<script>
import ExcretionAnalysis from '.'
import ExcretionTable from './Table'

import FormAnalysis from './Form'
import ColorAnalysis from './Color'
import VolumeAnalysis from './Volume'

export default {
	name: 'lifestyle-card-excretion-analysis',
	extends: ExcretionAnalysis,

	components: {
		ExcretionTable,
		FormAnalysis,
		ColorAnalysis,
		VolumeAnalysis
	}
}
</script>
<style lang="scss" scoped>
@import "../../component/table/style/analysis.scss";

$background: rgb(229, 240, 248);
$red: #f95a5a;
$yellow: #f5a623;
$green: #7ec635;

h6 {
	font-size: 12px;
	line-height: 24px;
	margin: 0;
	padding-left: 10px;
	color: #7f7f7f;
}
</style>
